import { useHead } from '#imports';
import type { SchemaOrgNode } from '~/utils/schemaOrg';

export const useSchemaOrgHead = (nodes: SchemaOrgNode[], key: string) => {
  if (!nodes.length) {
    return;
  }

  useHead({
    script: [
      {
        key,
        type: 'application/ld+json',
        innerHTML: JSON.stringify({
          '@context': 'https://schema.org',
          '@graph': nodes,
        }),
      },
    ],
  });
};
